import React from 'react'
import {
    Box,
    IconButton,
    Typography,
    Divider,
    ThemeProvider,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import PDFWebViewComponent from '../../../components/PDFWebViewComponent'
import { ArtosTheme } from '../../../components/Themes'
import OnlyOfficeViewerComponent from '../DocViewer'
import { v4 as uuidv4 } from 'uuid'

const SourceDocumentChunkPreview = ({
    chunk_info,
    templateURL,
    onClose,
    title,
    selectedText = null,
}) => {
    console.log('chunk info here', chunk_info)

    // Process page number, handling different formats
    let pageNumber = 1 // Default to page 1

    // Try all possible page number fields in priority order
    if (chunk_info?.pageNumber && typeof chunk_info.pageNumber === 'number') {
        pageNumber = chunk_info.pageNumber
    } else if (
        chunk_info?.initialPage &&
        typeof chunk_info.initialPage === 'number'
    ) {
        pageNumber = chunk_info.initialPage
    } else if (chunk_info?.page) {
        // Try to extract a number from the page field
        const pageStr = String(chunk_info.page)
        const pageMatch = pageStr.match(/\d+/)
        if (pageMatch) {
            pageNumber = parseInt(pageMatch[0], 10)

            // Apply document-specific page offset adjustments if not already applied
            // (Only apply if the pageNumber wasn't already set from chunk_info.pageNumber which should have offsets applied)
            const url = chunk_info.url || chunk_info.filename || ''
            if (url.includes('SAP')) {
                // Subtract 180 from SAP document pages
                pageNumber = Math.max(1, pageNumber - 180)
                console.log(`Preview: Adjusted SAP page to ${pageNumber}`)
            } else if (url.includes('TFL') || url.includes('Table')) {
                // Subtract 231 from TFL document pages
                pageNumber = Math.max(1, pageNumber - 231)
                console.log(`Preview: Adjusted TFL page to ${pageNumber}`)
            }
        }
    }

    // Convert to number explicitly and ensure it's a valid integer > 0
    pageNumber =
        typeof pageNumber === 'number' ? Math.max(1, Math.floor(pageNumber)) : 1

    console.log(
        'FINAL PAGE NUMBER TO USE:',
        pageNumber,
        'TYPE:',
        typeof pageNumber,
        'from source:',
        chunk_info
    )

    return (
        <ThemeProvider theme={ArtosTheme}>
            <Box
                sx={{
                    height: '100%',
                    width: '100%',
                    bgcolor: 'background.paper',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                {/* Header */}
                <Box
                    sx={{
                        p: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        bgcolor: 'background.default',
                    }}
                >
                    <Typography variant="h6" sx={{ fontSize: '1rem' }}>
                        {title || 'View Document'}
                    </Typography>
                    <IconButton
                        onClick={onClose}
                        size="small"
                        sx={{
                            '&:hover': {
                                bgcolor: 'rgba(0, 0, 0, 0.04)',
                            },
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>

                <Divider />

                {/* Document Viewer */}
                <Box sx={{ flex: 1, overflow: 'hidden' }}>
                    <Box
                        sx={{
                            height: '100%',
                            bgcolor: 'background.default',
                            borderRadius: 1,
                            overflow: 'hidden',
                            p: 1,
                        }}
                    >
                        {templateURL === null ? (
                            <PDFWebViewComponent
                                initialFile={
                                    chunk_info.url || chunk_info.filename
                                }
                                page={pageNumber}
                                selectedText={selectedText}
                            />
                        ) : (
                            <OnlyOfficeViewerComponent
                                initialFile={templateURL}
                                onLoaded={() => {
                                    console.log('Document loaded')
                                }}
                                documentName={title}
                                documentKey={uuidv4()}
                                displayType='embedded'
                            />
                        )}
                    </Box>
                </Box>
            </Box>
        </ThemeProvider>
    )
}

export default SourceDocumentChunkPreview
